import React from "react";
import { getStatusConfig } from "../../../utils/marketplaceHelpers";

const TransferStatusBadge = ({ status, lastError, showTooltip = true }) => {
  const config = getStatusConfig(status);

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 12px",
        borderRadius: "8px",
        backgroundColor: config.bgColor,
        fontSize: "14px",
        fontWeight: "500",
        color: config.color,
      }}
      title={showTooltip && lastError ? lastError : ""}
    >
      <span>{config.label}</span>
    </div>
  );
};

export default TransferStatusBadge;
